/**
 * Detail date text component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Detail date text component.
 */
const DetailDateText = styled.span<{ bold: boolean }>`
  color: ${Colors['text']};
  display: block;
  font-family: ${({ bold }) => (bold ? Fonts['bold'] : Fonts['thin'])};
  font-size: ${28 * Screen.widthRatio}px;
  line-height: ${32 * Screen.widthRatio}px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
`;

export default DetailDateText;
